export default __webpack_public_path__ + "media/images/mailer/icon_warning-041af2872aff724365dd0705339ccf9d.png";